<template>
	<div class="wrapper-shop">
		<div class="main-content" ref="scrolling-container">
			<div class="wrapper-navbar">
				<div class="row-nav">
					<div class="button-go-back" @click="goBackClick" >
						<AppChevronIcon :direction="'left'" v-if="currentIndex !== null" />
						<p>{{ currentIndex === null ? getString('products') : shopStore.shopItems[currentIndex].title }}</p>
					</div>
					<div class="button-cart" @click="shopStore.showCart = true">
						<img src="https://img.qromo.io/img/icon-cart.svg"  alt="icon cart">
						<div class="counter-number" v-if="shopStore.getTotalItemQuantity() > 0">
							<p>{{ shopStore.getTotalItemQuantity() }}</p>
						</div>
					</div>
				</div>
			</div>
			<div v-for="category in categories" :key="category.categoryId" v-if="currentIndex === null" class="container-card-listing">
				<div class="heading-categories">
					<h3>{{ category.title }}</h3>
					<p>{{ category.subtitle }}</p>
				</div>
				<div class="item-listing">
					<CardListing :key="index" v-for="(card, index) in this.shopStore.shopItems.filter(item => item.categoryId === category.categoryId)" :card="card" @click="clickItem(card)" />
				</div>
			</div>
			<div v-else>
				<CardDetails @close="currentIndex = null" :card="shopStore.shopItems[currentIndex]" />
			</div>
		</div>
		<div class="container-shop">
			<CartShop />
		</div>
	</div>
</template>

<script>
import {useCurrencyStore, useLanguageStore, useScriptStore} from "@/shared/stores";
import CardListing from "@/shop/components/CardListing.vue";
import CardDetails from "@/shop/components/CardDetails.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import CartShop from "@/shop/components/CartShop.vue";
import {useShopStore} from "@/shop/stores";
import {customEvent} from "@/shared/helpers/events";


export default {
	components: {AppChevronIcon, CardDetails, CardListing, CartShop},
	setup() {
		const languageStore = useLanguageStore();
		const scriptStore = useScriptStore();
		const shopStore = useShopStore();
		const currencyStore = useCurrencyStore();
		return {languageStore, getString: languageStore.getString, scriptStore, shopStore, currencyStore};
	},
	name: "AppShop",
	data() {
		return {
			currentIndex: null,
			clickedItemScrollPosition: 0,
			restoreScrollPositionTimeout: null
		}
	},
	methods: {
		submitNavigationPage(top = 0) {
			const mainContent = this.$el.querySelector('.main-content');
			if (mainContent) {
				mainContent.scrollTo({
					top: top || 0,
					behavior: 'instant'
					//behavior: smooth ? 'smooth' : 'instant'
				});
			}
		},
		updateCurrentIndexByRoute() {
			let currentRoute = this.$route.path;
			let currentRouteSplit = currentRoute.split("/");
			let lastRoute = currentRouteSplit.pop();
			if (lastRoute !== "shop") {
				let lastRouteIndex = this.shopStore.shopItems.findIndex(item => item.id === lastRoute);
				if (lastRouteIndex !== -1) {
					this.currentIndex = lastRouteIndex;
				}
			} else {
				this.currentIndex = null;
			}
		},
		clickItem(card) {
			clearTimeout(this.restoreScrollPositionTimeout);
			this.clickedItemScrollPosition = this.$refs?.['scrolling-container']?.scrollTop || 0;
			this.submitNavigationPage(0);
			this.$router.push("/plugins/shop/" + card.id);
			customEvent('select_item', {
				currency: this.currencyStore.currCurrency?.code,
				value: this.shopStore.currencyItemPrice(card),
				items: [{
					item_id: card.id,
					item_name: card.title,
					item_category: card.categoryId,
					price: this.shopStore.currencyItemPrice(card),
					quantity: 1
				}]
			});
		},
		goBackClick() {
			clearTimeout(this.restoreScrollPositionTimeout);
			this.restoreScrollPositionTimeout = setTimeout(() => {
				this.submitNavigationPage(this.clickedItemScrollPosition);
			}, 100);
			this.$router.push("/plugins/shop");
		}
	},
	computed: {
		categories() {
			const languageStore = useLanguageStore();
			return [{
				categoryId: "POS",
				title: languageStore.getString('pos_category_title'),
				subtitle:  languageStore.getString('pos_category_subtitle'),
			},{
				categoryId: "tablet",
				title: languageStore.getString('tablet_category_title'),
				subtitle:  languageStore.getString('tablet_category_subtitle'),
			},{
				categoryId: "printer",
				title: languageStore.getString('printer_category_title'),
				subtitle:  languageStore.getString('printer_category_subtitle'),
			}]
		},
	},
	mounted() {
		this.updateCurrentIndexByRoute();
	},
	watch: {
		"$route.path"() {
			this.updateCurrentIndexByRoute();
		}
	}
}
</script>

<style lang="scss" scoped>
.wrapper-shop {
	display: flex;
	height: 100%;
	width: 100%;
	position: absolute;
	top: 0;
	left: 0;
	overflow: hidden;
	.main-content {
		display: flex;
		flex-direction: column;
		padding: 0 4px 0 0;
		width: 100%;
		@include hideScrollbar();
		
		@media(max-width: 1440px) {
			padding: 0;
		}

		.wrapper-navbar {
			background: rgba(var(--rgb-bg-primary-1), 67%);
			box-shadow: inset -3px -3px 6px var(--color-box-shadow-2);
			border-radius: 0 0 13px 0;
			padding: 10px;
			position: sticky;
			top: 0;
			z-index: 9;
			backdrop-filter: blur(10px);
			-webkit-backdrop-filter: blur(10px);
			@media(max-width: 420px) {
				padding: 20px 10px 0 10px;
			}
			.row-nav {
				display: flex;
				border-radius: 13px;
				box-shadow: 0px -1px 2px var(--color-box-shadow-3);
				height: 45px;
				justify-content: space-between;
				align-items: center;
				margin-bottom: 0;
				background-color: var(--color-bg);
				.button-go-back {
					display: flex;
					align-items: center;
					height: 100%;
					padding: 0 20px;
					cursor: pointer;
					p {
						margin-left: 5px;
						text-align: left;
						font: normal normal bold 16px/19px Montserrat;
						color: var(--color-txt);
					}
				}
				.button-cart {
					position: relative;
					width: 45px;
					height: 45px;
					display: flex;
					align-items: center;
					justify-content: center;
					background-color: var(--color-bg-primary-2);
					border-radius: 13px;
					.counter-number {
						position: absolute;
						display: flex;
						align-items: center;
						justify-content: center;
						top: -5px;
						right: -5px;
						background-color: var(--color-primary);
						border-radius: 20px;
						width: 20px;
						height: 20px;
						p {
							color: var(--color-txt-white);
							font-size: 12px;
						}
					}
				}
			}
		}

		.container-card-listing {
			padding: 20px;
			@media(max-width: 420px) {
				padding: 20px 10px;
			}
			@media(max-width: 300px) {
				padding: 20px 10px;
			}
		}
		.item-listing {
			display: flex;
			flex-wrap: wrap;
			justify-content: flex-start;
			gap: 20px;
			@media(max-width: 650px) {
				justify-content: center;
			}
		}
	}
	.container-shop {
		height: 100%;
	}
	.heading-categories {
		margin: 20px 0 40px;
		padding: 0 20px 20px;
		border-bottom: 1px solid var(--color-alpha-4);
		h3 {
			font: normal normal bold 20px/26px Montserrat;
			color: var(--color-txt);
			margin-bottom: 3px;
		}
		p {
			font: normal normal medium 14px/16px Montserrat;
			color: var(--color-txt-1);
		}
	}
}
</style>